// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"5787d8df","515":"e72497e1","739":"6501b94e"}[chunkId] + ".chunk.js";
};